import React, { Dispatch, SetStateAction } from 'react'
import { FoundationsConstants } from './FoundationsConstants'
declare let window: any
const UnicornApp = window.unicornInstance as any
import axios, { AxiosResponse, AxiosRequestConfig, AxiosError } from 'axios'
import Cookies from 'js-cookie'
import { encryptData, setCookie, setHLUserCookies } from './GlobalMethods'
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export function getBaseUrl() {
    return FoundationsConstants.BASE_URL
}

interface axiosProps {
    url: string
    data?: Object
    context?: Object
    success?: Function
    error?: Function
    beforeSend?: Function
    cache?: boolean
    headers?: { [key: string]: any }
    triggerEvents?: {
        Started: boolean | String
        EndedSuccesfully: boolean | String
        EndedWithFailure: boolean | String
    }
    includeTokenHeader?: boolean
    Started?: Boolean
}

const axiosApi = axios.create({
    baseURL: getBaseUrl(),
})

const requestInterceptor = (config: AxiosRequestConfig) => {
    if (config.headers['Content-Type'] == undefined)
        config.headers['Content-Type'] = 'application/json; charset=utf-8'
    return config
}
axiosApi.interceptors.request.use(requestInterceptor)

export async function FoundationsRequest(
    type: 'GET' | 'POST' | 'PUT' | 'DELETE',
    options: axiosProps
) {
    const originalSuccess = options.success
    const originalError = options.error
    const triggerEvents = options.triggerEvents
    // var token = window.healthLevelGlobal.getCookie('hl-user-token')
    // const hl_user_token = options?.includeTokenHeader ? Cookies.get(FoundationsConstants.TOKEN_STR) : null
    // const hl_user_token = store.getState().userdata?.userToken || null
    const hl_user_token = ''

    //         if (token)
    //             xhr.setRequestHeader('hl-user-token', token);

    // if (UnicornApp.userFeedbackChannel) {     FP-10380 Commenting this because of UNICORNAPP reference.
    //     UnicornApp.userFeedbackChannel.trigger(
    //         (triggerEvents && triggerEvents.Started) || 'HLModel:FetchStarted',
    //         {
    //             context: options.context,
    //         }
    //     )
    // }


    let axiosHeaders: any = options.cache
        ? {
              ...options.headers,
              'Cache-Control': 'no-cache',
              Pragma: 'no-cache',
              Expires: '0',
              'hl-user-token': hl_user_token,
          }
        : { ...options.headers, 'hl-user-token': hl_user_token}

    if (hl_user_token !== null) axiosHeaders[FoundationsConstants.TOKEN_STR] = hl_user_token

    try {
        if (options.beforeSend !== undefined) options.beforeSend()

        const response: AxiosResponse =
            type === 'POST'
                ? await axiosApi.post(options.url, options.data, {
                    headers: axiosHeaders,
                })
                : type === 'DELETE'
                    ? await axiosApi.delete(options.url, options.data)
                    : type === 'PUT'
                        ? await axiosApi.put(options.url, {
                            headers: axiosHeaders,
                        })
                        : await axiosApi.get(options.url, {
                            headers: axiosHeaders,
                            params: options.data,
                        })

        const data = await response.data
        // if (UnicornApp.userFeedbackChannel) {
        //     UnicornApp.userFeedbackChannel.trigger(
        //         (triggerEvents && triggerEvents.EndedSuccesfully) ||
        //         'UnicornRequest:EndedSuccesfully',
        //         {
        //             data: data,
        //             textstatus: response.statusText,
        //             context: options.context,
        //         }
        //     )
        // }
        if (originalSuccess !== undefined) {
            originalSuccess(data, response.statusText)
        }
    } catch (error) {
        const axiosError = error as AxiosError
        // if (UnicornApp.userFeedbackChannel) {
        //     UnicornApp.userFeedbackChannel.trigger(
        //         (triggerEvents && triggerEvents.EndedWithFailure) ||
        //         'UnicornRequest:EndedWithFailure',
        //         {
        //             textStatus: axiosError.response?.statusText,
        //             errorThrown: axiosError,
        //             context: options.context,
        //         }
        //     )
        // }
        console.error("Request failed: ");
        console.error(axiosError)

        if (originalError !== undefined) {
            originalError(axiosError.response?.statusText, axiosError)
        }
    }
}

export const getBaseQuery = (baseUrl: string) =>{
    return fetchBaseQuery({
      baseUrl,
      prepareHeaders: (headers, { getState } ) => { 
        headers.set("hl-user-token", ((getState() as {[s:string]:any}).userdata?.userToken || ''));
        return headers;
      },
    });
}

export function updateHookArray(
    value: any,
    index: number,
    oldArray: any[],
    hook: Dispatch<SetStateAction<any>>
) {
    const newArray = [...oldArray]
    newArray[index] = value
    hook(newArray)
}

export const passwordValidate = (val: string, firstName: string, lastName: string) => {
    if (
        (firstName.length > 3 && val.toLowerCase().includes(firstName.toLowerCase())) ||
        (lastName.length > 3 && val.toLowerCase().includes(lastName.toLowerCase()))
    ) {
        return 'Password cannot contain the first name or the last name.'
    } else if (/^\s+/.test(val)) {
        return 'Password cannot contain leading spaces.'
    } else if (/[ \t]+$/.test(val)) {
        return 'Password cannot contain trailing spaces.'
    } else {
        return true
    }
}

export async function handleHardReload(url: string) {
    await fetch(url, {
        headers: {
            Pragma: 'no-cache',
            Expires: '-1',
            'Cache-Control': 'no-cache',
        },
    })
    window.location.href = url
    window.location.reload()
}

export function addJsScriptSync(newURL: string, id: string = '') {
    if (!isScriptLoaded(newURL)) {
        const script = document.createElement('script')
        script.src = newURL
        script.async = false
        document.head.appendChild(script)
    }
}

export function isScriptLoaded(url: string) {
    var scripts = document.getElementsByTagName('script')
    for (var i = scripts.length; i--; ) {
        if (scripts[i].src == url) return true
    }
    return false
}

export const formatDate = (input?: Date | string): string => {
    const targetDate = input ? (typeof input === 'string' ? new Date(input) : input) : new Date()

    const month = String(targetDate.getMonth() + 1).padStart(2, '0')
    const day = String(targetDate.getDate()).padStart(2, '0')
    const year = targetDate.getFullYear()

    let hours = targetDate.getHours()
    const minutes = String(targetDate.getMinutes()).padStart(2, '0')
    const ampm = hours >= 12 ? 'PM' : 'AM'
    hours = hours % 12 || 12

    return `${month}-${day}-${year} ${hours}:${minutes}${ampm}`
}
export const genericValueToEnum = function (t: any, value: any) {
    for (const item in t) {
        if (t[item] == value) {
            return Number.parseInt(item)
        }
    }
    return undefined
}

export function getDistanceFromTop(element: HTMLElement) {
    const rect = element.getBoundingClientRect()
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop
    return rect.top + scrollTop
}

export function isOperationAllowed(userTypeId: string, operation: any) {
    let operationallowed = false
    if (userTypeId == 'SystemAdmin') {
        operationallowed = true
    } else if (userTypeId == 'SimpleUser') {
        if (window.healthLevelGlobal.featureSecurityList == null) {
            window.healthLevelGlobal.getFeatureSecurityList().then(function () {
                operationallowed =
                    window.healthLevelGlobal.featureSecurityList.indexOf(operation) > -1
            })
        } else {
            operationallowed = window.healthLevelGlobal.featureSecurityList.indexOf(operation) > -1
        }
    }

    return operationallowed
}

export function date_mmddyy (d: Date) {

    const month = (d.getMonth() + 1).toString().padStart(2, '0');
    const date = d.getDate().toString().padStart(2, '0');
    const year = d.getFullYear().toString().slice(-2);

    return `${month}${date}${year}`;
}
;

export function decodeHtml(html: string) {
    const txt = document.createElement('textarea');
    txt.innerHTML = html;
    return txt.value;
  }

  export function getUrlVars() {
    var vars : {[s:string]:any}= {};
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m: any, key: string | number, value: any) {
        vars[key] = value;
    });
    return vars;
}

export function toBinary(input: string){
    const codeUnits = new Uint16Array(input.length)
    for (let i = 0; i < codeUnits.length; i++) {
        codeUnits[i] = input.charCodeAt(i)
    }
    return btoa(String.fromCharCode(...new Uint8Array(codeUnits.buffer)))
}

export const isSecurityFeatureAllowed = (featureSecurityList: any[], allowedPrivilegesList: any[]) => {
      for (let i = 0; i < allowedPrivilegesList.length; i++) {
          if ( featureSecurityList.includes(allowedPrivilegesList[i])) {
              return true;
          }
      }
      return false;
  }